export default __webpack_public_path__ + "assets/locker-38c19b0.svg";